module.exports = __webpack_public_path__ + "img/sportage-22.1e7546ff.png";